/** localStorage key for admin review API token (X-Admin-Token). */
export const ADMIN_REVIEW_TOKEN_KEY = 'admin_review_token';

export function getAdminReviewToken(): string | null {
  const t = localStorage.getItem(ADMIN_REVIEW_TOKEN_KEY);
  return t && t.trim() ? t.trim() : null;
}

export function setAdminReviewToken(token: string): void {
  localStorage.setItem(ADMIN_REVIEW_TOKEN_KEY, token.trim());
}

export function clearAdminReviewToken(): void {
  localStorage.removeItem(ADMIN_REVIEW_TOKEN_KEY);
}

export function hasAdminReviewToken(): boolean {
  return getAdminReviewToken() !== null;
}
